import { CEDE_CEXS } from "../cexs";

export const API_KEY_LABELS = {
  [CEDE_CEXS.BINANCE]: {
    public: "API key",
    secret: "Secret key",
  },
  [CEDE_CEXS.BITFINEX]: {
    public: "API key",
    secret: "API key secret",
  },
  [CEDE_CEXS.COINBASE]: {
    public: "API key",
    secret: "API secret",
  },
  [CEDE_CEXS.HTX]: {
    public: "Access key",
    secret: "Secret key",
  },
  [CEDE_CEXS.KUCOIN]: {
    public: "Key",
    secret: "Secret",
  },
  [CEDE_CEXS.OKX]: {
    public: "API key",
    secret: "Secret key",
  },
};

export const KRAKEN_TRADE_HISTORY_PERMISSION_LABEL = "Query Closed Orders & Trades";
